// extracted by mini-css-extract-plugin
export default {"wrapper":"Rp-nR","container":"Ajtuy"};